import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    OnInit,
    Signal,
    WritableSignal,
    computed,
    inject
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DatiqUtilsDirectiveModule } from '@dat/datiq-components-pkg/utils';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';
import { DATE_FORMAT, IIqLinksBlogArticle } from '../models';
import { IqLinksBlogStateService } from '../state';

@Component({
    selector: 'iq-links-blog-links',
    standalone: true,
    imports: [CommonModule, MatTooltipModule, DatiqUtilsDirectiveModule],
    templateUrl: './iq-links-blog-links.component.html',
    styleUrl: './iq-links-blog-links.component.scss',
})
export class IqLinksBlogLinksComponent implements OnInit {
    
    @Input({ required: true }) id: string;
    @Input({ required: true }) articlesLimit: number;

    loaded: Signal<boolean>;
    articles: WritableSignal<IIqLinksBlogArticle[]>;
    rowsArray: any[];
    rowsTruncated: boolean[];

    DATE_FORMAT = DATE_FORMAT;

    private _eventBus: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );

    constructor(private readonly _state: IqLinksBlogStateService) {}

    ngOnInit() {
        this.articles = this._state.getArticles(this.articlesLimit);

        this.rowsArray = new Array(this.articlesLimit);
        this.rowsTruncated = this.rowsArray.map(() => false);

        this.loaded = computed(() => {
            return !!this.articles()?.length;
        });
    }

    shortName(name: string): string {
        return name.slice(0, 50) + '...';
    }

    clickedLink(url: string) {
        /**
         * This dispatches an event when the link is clicked
         *
         *
         * To listen to these events, you can use the following format in your Dashboard, Section, or Component:
         *
         * ```json
         * {
         *  "onClick": [
         *    {
         *      "name": "EVENT_NAME",
         *      "payload": {},
         *      "sourceEventRule": {
         *          "payload": [
         *            {
         *                "path": "id",
         *                "operator": "eq",
         *                "value": "COMPONENT_ID"
         *            },
         *            {
         *                "path": "componentName",
         *                "operator": "eq",
         *                "value": "IqLinksBlogLinks"
         *            },
         *          ]
         *      },
         *      "rules": []
         *    },
         *   ],
         * }
         * ```
         */
        const dispatch = () =>
            this._eventBus.dispatch({
                name: 'type:click',
                payload: {
                    id: this.id,
                    componentName: 'IqLinksBlogLinks',
                    url,
                },
            });

        dispatch();
    }
}
